import { Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { get } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import { IPlanoERPSchema } from "../../Interfaces/financeiro/financeiro";
import { ICaderno } from "../../Interfaces/cadernos/caderno1";
import { IPage2 } from "../../Interfaces/cadernos/caderno2";


interface I_aux {
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    obj_new: IPlanoERPSchema | undefined,
    lista_caraterizacao: IPage2[],
    lista_cadernos_ativos: ICaderno[],
    set_lista_caraterizacao: React.Dispatch<React.SetStateAction<IPage2[]>>,
}

export const Modalverfinanceiro: React.FC<I_aux> = ({
    flag_open_modal,
    set_flag_open_modal,
    set_flag_open_modal_ver_mais,
    obj_new,
    lista_caraterizacao,
    lista_cadernos_ativos,
    set_lista_caraterizacao
}) => {
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const areasSelecionadas = lista_caraterizacao.filter(
        (item) => item.id_cara != null && obj_new?.id_cara?.includes(item.id_cara)
    );
    const cadernoSelecionado = lista_cadernos_ativos.find(item => item.id_rosto === obj_new?.id_rosto);

    const get_info_by_id_cara = async () => {
        try {
            setIsLoading(true);
            let res = await get(auth.token.cookie_token, `/get_caraterizacao_id_rosto/${obj_new?.id_rosto}`);

            if (res.status === 200) {
                set_lista_caraterizacao(res.data.result);
            }
            setIsLoading(false);

        } catch (error) {
            func_print("get_info_by_id_cara", error, true);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        (async () => {
            await get_info_by_id_cara();
        })();
    }, []);

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    Detalhes do Plano ERP

                </h2>
                <button
                    type="button"
                    onClick={() => {
                        set_flag_open_modal(false)
                        set_flag_open_modal_ver_mais(false)
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                            <div className="flex flex-col w-full flex-1 overflow-auto p-6 gap-6">

                                <div className="w-full rounded-xl bg-gray-50/70 border border-gray-100 p-5">
                                    <div className="mb-4 text-xs font-semibold uppercase tracking-wider text-gray-400">
                                        Associações
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
                                        <div>
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                                Caderno do Plano ERP
                                            </div>
                                            <div className="text-base font-medium text-gray-800 break-words">
                                                {cadernoSelecionado?.nome || '-'}
                                            </div>
                                        </div>

                                        <div>
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                                Área de Compromisso
                                            </div>

                                            <div className="text-base font-medium text-gray-800 break-words">
                                                {areasSelecionadas.length > 0
                                                    ? areasSelecionadas
                                                        .map(
                                                            (area) => `${area.parcela_numero} - ${area.nome_parcela ?? ''}`
                                                        )
                                                        .join(', ')
                                                    : '-'}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="w-full rounded-xl bg-gray-50/70 border border-gray-100 p-5">
                                    <div className="mb-4 text-xs font-semibold uppercase tracking-wider text-gray-400">
                                        Detalhes do Plano ERP
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5 w-full items-start">
                                        <div>
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Designação</div>
                                            <div className="text-base font-medium text-gray-800">{obj_new?.nome || '-'}</div>
                                        </div>

                                        <div>
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Ano</div>
                                            <div className="text-base font-medium text-gray-800">{obj_new?.ano || '-'}</div>
                                        </div>

                                        <div>
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Descrição</div>
                                            <div className="text-base font-medium text-gray-800">{obj_new?.descricao || '-'}</div>
                                        </div>

                                        <div className="md:col-span-2">
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Cultura</div>
                                            <div className="text-base font-medium text-gray-800">{obj_new?.cultura || '-'}</div>
                                        </div>

                                        <div>
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Estado</div>
                                            <div className="text-base font-medium text-gray-800">{obj_new?.estado || '-'}</div>
                                        </div>

                                        <div>
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Orçamento Total</div>
                                            <div className="text-base font-medium text-gray-800">{obj_new?.orcamento_total || '-'}</div>
                                        </div>

                                        <div>
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Alerta Percentagem</div>
                                            <div className="text-base font-medium text-gray-800">{obj_new?.alerta_percentagem || '-'}</div>
                                        </div>

                                        <div>
                                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Tipo de Entidade</div>
                                            <div className="text-base font-medium text-gray-800">{obj_new?.tipo_entidade || '-'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }

        </div>



    </Modal>)

}
